import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';


import {HttpClient} from '@angular/common/http';
import {BaseRestService} from '../common/BaseRestService';

@Injectable()
export class LocationRestService extends BaseRestService {

  constructor(private http: HttpClient) {
    super('locations');
  }

  getLocationTypes(): Observable<any> {
    return this.http.get<any[]>(this.getEndpoint(['types']));
  }
}
